import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async listSuppliersPaginated(
        { commit, dispatch },
        { complete, itemsByPage, page }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/suppliers", {
                params: { complete, itemsByPage, page }
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_SUPPLIERS", parseError);
            throw parseError;
        }
    },
    async getSupplierById({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.get(`/bo/suppliers/${id}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_SUPPLIERS", parseError);
            throw parseError;
        }
    },
    async createSupplier(
        { commit, dispatch },
        {
            address,
            addressComplement,
            cityCode,
            coordinates,
            identificationNumber,
            identificationType,
            name,
            neighborhood,
            phone,
            summary
        }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/suppliers", {
                name,
                phone,
                identificationType,
                identificationNumber,
                summary,
                address,
                addressComplement,
                cityCode,
                neighborhood,
                coordinates
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_SUPPLIERS", parseError);
            throw parseError;
        }
    },
    async updateSupplier(
        { commit, dispatch },
        {
            address,
            addressComplement,
            cityCode,
            coordinates,
            id,
            identificationNumber,
            identificationType,
            name,
            neighborhood,
            phone,
            summary
        }
    ) {
        try {
            const { data } = await Http.instance.patch(`/bo/suppliers/${id}`, {
                address,
                addressComplement,
                cityCode,
                coordinates,
                identificationNumber,
                identificationType,
                name,
                neighborhood,
                phone,
                summary
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_SUPPLIERS", parseError);
            throw parseError;
        }
    }
};

export default actions;
